module.exports = __webpack_public_path__ + "static/img/top-0.3be0ba24.png";